export enum AccountSelectionActionTypes {
  SET_SELECTED_ACCOUNT = 'SET_SELECTED_ACCOUNT',
  SET_AVAILABLE_ACCOUNTS = 'SET_AVAILABLE_ACCOUNTS',
  UPDATE_ACCOUNT_SELECTION = 'UPDATE_ACCOUNT_SELECTION',
  CLEAR_ACCOUNT_SELECTION = 'CLEAR_ACCOUNT_SELECTION',
  ACCOUNT_SELECTION_LOADING = 'ACCOUNT_SELECTION_LOADING',
  ACCOUNT_SELECTION_ERROR = 'ACCOUNT_SELECTION_ERROR',
  ACCOUNT_SELECTION_CLEANUP = 'ACCOUNT_SELECTION_CLEANUP',
  CREATE_ACCOUNT_LOADING = 'CREATE_ACCOUNT_LOADING',
  CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS',
  CREATE_ACCOUNT_ERROR = 'CREATE_ACCOUNT_ERROR',
  UPDATE_ACCOUNT_LOADING = 'UPDATE_ACCOUNT_LOADING',
  UPDATE_ACCOUNT_SUCCESS = 'UPDATE_ACCOUNT_SUCCESS',
  UPDATE_ACCOUNT_ERROR = 'UPDATE_ACCOUNT_ERROR',
  DELETE_ACCOUNT_LOADING = 'DELETE_ACCOUNT_LOADING',
  DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS',
  DELETE_ACCOUNT_ERROR = 'DELETE_ACCOUNT_ERROR',
  GET_ACCOUNT_LOADING = 'GET_ACCOUNT_LOADING',
  GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS',
  GET_ACCOUNT_ERROR = 'GET_ACCOUNT_ERROR',
}
